import { Reveal, SectionHeading } from "./Reveal";
import { PROCESS_STEPS } from "@/data/site";

const Process = () => (
  <section data-testid="process-section" className="bg-white py-24 md:py-32 lg:py-40">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHeading
        align="center"
        overline="How It Works"
        title="From Idea To Intelligent System"
        text="A clear, collaborative process — so you always know what happens next."
      />

      <div className="relative mt-20">
        <div
          aria-hidden
          className="absolute left-[27px] top-0 h-full w-px bg-gradient-to-b from-electric/50 via-slate-200 to-transparent lg:left-0 lg:top-[27px] lg:h-px lg:w-full lg:bg-gradient-to-r"
        />
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-4 lg:gap-8">
          {PROCESS_STEPS.map((step, i) => (
            <Reveal key={step.number} delay={i * 0.12}>
              <div
                data-testid={`process-step-${step.number}`}
                className="group relative flex gap-6 lg:flex-col lg:gap-0"
              >
                <div className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border border-electric/25 bg-white font-display text-lg font-semibold text-electric shadow-sm transition-[background-color,color,box-shadow] duration-500 group-hover:bg-electric group-hover:text-white group-hover:shadow-[0_0_24px_rgba(37,99,235,0.4)]">
                  {step.number}
                </div>
                <div className="lg:mt-7">
                  <h3 className="font-display text-xl font-medium text-slate-900">{step.title}</h3>
                  <p className="mt-2.5 max-w-xs text-sm leading-relaxed text-slate-600">
                    {step.text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Process;
